import { StoreWithStrapi } from "../../types/types";

export const selectReportAnswers = (state: StoreWithStrapi): any[] =>
  state.gop.reports?.answers?.data || [];

export const selectReportStatuses = (state: StoreWithStrapi): any[] =>
  state.gop.reports?.statuses?.data || [];

export const selectReportAnswersLoading = (state: StoreWithStrapi): boolean =>
  state.gop.reports?.answers?.loading || false;

export const selectReportStatusesLoading = (state: StoreWithStrapi): boolean =>
  state.gop.reports?.statuses?.loading || false;

export const selectReportCombinedLoading = (state: StoreWithStrapi): boolean =>
  state.gop.reports?.combined?.loading || false;

export const selectReportAnswersError = (state: StoreWithStrapi): string | null =>
  state.gop.reports?.answers?.error || null;

export const selectReportStatusesError = (state: StoreWithStrapi): string | null =>
  state.gop.reports?.statuses?.error || null;

export const selectReportCombinedError = (state: StoreWithStrapi): string | null =>
  state.gop.reports?.combined?.error || null;